class e extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M14.295 6.655 15 5.95 10 1l-.655.71.59.59L4.19 7.16l-.86-.855L2.625 7l2.83 2.84L1 14.29l.705.71 4.455-4.455L9 13.375l.695-.71-.855-.855 4.86-5.745.595.59ZM8.13 11.1 4.9 7.87 10.645 3 13 5.355 8.13 11.1Z"></path></svg>';
  }
}
const t = "pi-pin";
customElements.get(t) || customElements.define(t, e);
export {
  e as default
};
